export default "__VITE_ASSET__B4Z9eVyL__"